// extracted by mini-css-extract-plugin
export default {"tasks":"BR-z","task":"CR-z","svg":"DR-z","text":"ER-z"};